<app-header-public></app-header-public>
<!-- Main Content -->
<main role="main" class="content__main">
  <!-- Begin Begin Page Content -->
  <div class="container pt-3">

    <!-- Title -->
    <div class="d-sm-flex align-items-center justify-content-between mb-2">
      <h1 class="font-weight-bold h3 mb-0 text-gray">Términos y Condiciones</h1>
    </div>
    <!-- End Title -->

    <!-- Breadcrumb -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['','login']"><i class="far fa-user"></i></a></li>
        <li class="breadcrumb-item active" aria-current="page">Términos y Condiciones</li>
      </ol>
    </nav>
    <!-- End Breadcrumb -->

    <!-- Content -->
    <div class="row">

      <!-- Header -->
      <div class="col-md-12">
        <div *ngIf="cmsData" class="banner">
          <app-advertisements *ngIf="cmsData.espacios[1]"  [typeContent]="'espacios'" [positions]="1" [contentData]="cmsData"></app-advertisements>
        </div>
      </div>
      <!-- End Header -->

      <div class="col-md-8 mb-4 order-md-1">
        <div *ngIf="cmsData" >
          <app-advertisements *ngIf="cmsData.espacios[2]"  [typeContent]="'espacios'" [positions]="2" [contentData]="cmsData"></app-advertisements>
        </div>
      </div>

      <!-- Sidebar -->
      <div class="col-md-4 order-md-2 mb-4">
        <div *ngIf="cmsData" class="banner">
          <app-advertisements *ngIf="cmsData.espacios[3]"  [typeContent]="'espacios'" [positions]="3" [contentData]="cmsData"></app-advertisements>
        </div>
      </div>
      <!-- End Sidebar -->

    </div>
    <!-- End Content -->

  </div>
  <!-- End Begin Page Content -->
</main>
<!-- Main Content -->


<app-footer></app-footer>
